import { Router, ActivatedRoute } from '@angular/router';
import { Component, HostListener } from '@angular/core';
import { SharedService } from 'src/app/services/shared.service';
import { CatalogsService } from 'src/app/services/catalogs.service';
import { MessagesService } from 'src/app/services/messages.service';
import { GetAniosService } from 'src/app/services/get-anios.service';
import { DeductivaService } from 'src/app/services/deductiva.service';
import { NavigationService } from 'src/app/services/navigation.service';
import { PaginationService } from 'src/app/services/pagination.service';
import { FiltrarProyectosService } from 'src/app/services/filtrar-proyectos.service';
import { MESES } from 'src/app/constants/months.const';
import { ESTATUS } from 'src/app/constants/status.const';

@Component({
  selector: 'app-penalizacion',
  templateUrl: './penalizacion.component.html',
  styleUrls: ['./penalizacion.component.css']
})
export class PenalizacionComponent {

  penalizaciones: any[] = [];
  penalizacionesOriginales: any[] = [];
  penalizacionesFiltradas: any[] = [];
  proyectos: any[] = [];

  estatus: any = null;
  buscar: any = null;
  proyecto: any = null;
  mes: any = null;
  anio: any = null;

  rol: any;
  token: any;
  usuarioId: any;
  idProyectos: any;

  currentPage: number = 1;
  totalPages: number = 1;
  maxVisiblePages: number = 2;
  totalPagesArray: number[] = [];

  mensajePenalizacion: string = '';
  activarMensaje: string = '';

  public rango: number = 5;
  public opciones: number[] = [5, 10, 15, 20];

  public body: any;
  public llegada: any;

  public lastAction: string = '';

  public loading: boolean = false;
  public isDocumentLoading = false;
  public progress = 0;

  public mensajeLoading: string = 'Cargando Penalizaciones...';

  public isFiltersOpen: boolean = false;
  public anios: any;
  
  meses = MESES;
  status = ESTATUS;

  constructor(
    private router: Router,
    private route: ActivatedRoute,
    private sharedService: SharedService,
    private pagination: PaginationService,
    private getAniosService:GetAniosService,
    private messagesService: MessagesService,
    private requestsService: DeductivaService,
    private requestsService2: CatalogsService,
    private navigationService: NavigationService,
    private filtrarProyectosService: FiltrarProyectosService) {
    this.filtrollegada();
   }

  ngOnInit() {
    this.verificacionUsuario();
    this.fetchData();
    this.getYears();
  }

  trackByFn(index: number, item: any): any {
    return item;
  }

  obtenerfiltrosGuardados(){
    let urlCompleta = this.router.url;
    let compararUrl = urlCompleta.split('?')[0].split('/')[1];
    let filtrado: any = this.filtrarProyectosService.getFilter();

    if(filtrado !== undefined){
      if(compararUrl === filtrado.pantalla){
        this.estatus = filtrado.estatus;
        this.proyecto = filtrado.proyecto;
        this.mes = filtrado.mes;
        this.anio = filtrado.anio;
        this.buscar = filtrado.buscar;
      }
    }

    this.isFiltersOpen = this.estatus !== null || this.proyecto !== null || this.mes !== null || this.anio !== null || this.buscar !== null;
  }
  
  filtrollegada(){
    this.route.queryParams.subscribe(params => {
      this.estatus = params['estado'] || null;
    });
    this.obtenerfiltrosGuardados();
  }

  verificacionUsuario() {
    this.llegada = this.pagination.getLastAction();
    if(this.llegada.rangoPaginas !== undefined){
      this.rango = this.llegada.rangoPaginas;
    }

    this.navigationService.disableNavigation();
    const { rol, usuarioId, token } = this.filtrarProyectosService.validacionUsuarios();
    this.token = token;
    this.usuarioId = usuarioId;
    this.rol = rol;
  }

  @HostListener('window:resize', ['$event'])
  onResize(event: any): void {
    this.adjustMaxVisiblePages();
  }

  adjustMaxVisiblePages(): void {
    const width = window.innerWidth;
    if (width < 576) {
      this.maxVisiblePages = 3;
    } else if (width < 768) {
      this.maxVisiblePages = 5;
    } else {
      this.maxVisiblePages = 7;
    }
  }

  get visiblePages(): (number | string)[] {
    const pages: (number | string)[] = [];

    if (this.totalPages <= this.maxVisiblePages) {
      for (let i = 1; i <= this.totalPages; i++) {
        pages.push(i);
      }
    } else {
      let startPage = Math.max(1, this.currentPage - Math.floor(this.maxVisiblePages / 2));
      let endPage = Math.min(this.totalPages, startPage + this.maxVisiblePages - 1);

      if (endPage - startPage < this.maxVisiblePages - 1) {
        startPage = Math.max(1, endPage - this.maxVisiblePages + 1);
      }

      if (startPage > 1) {
        pages.push(1);
      }
      if (startPage > 2) {
        pages.push('...');
      }
      for (let i = startPage; i <= endPage; i++) {
        pages.push(i);
      }
      if (endPage < this.totalPages - 1) {
        pages.push('...');
      }
      if (endPage < this.totalPages) {
        pages.push(this.totalPages);
      }
    }

    return pages;
  }

  activarDondeQuedo(){
    if (this.llegada.lastAction === 'back') {
      this.pagination.setLastAction('');
    }
  }

  cargando(activar:boolean, documento:boolean){
    this.loading = activar;
    this.isDocumentLoading = documento;
    this.progress = 0;
  }

  getBody(){
    this.body = this.pagination.getPagination(this.currentPage, this.rango, this.buscar, this.estatus, this.proyecto, 'penalizacion',  this.anio, this.mes);
  }

  fetchData() {
    this.getBody();
    this.activarMensaje = 'inicial';
    this.obtenerTodasPenalizacion();
    this.obtenerProyectos();
  }

  getYears(){
    this.getAniosService.obtenerAnios().subscribe(
      (data: any) => {
        this.anios = data;
      }, (err) => {
        this.messagesService.showError(err.message);
      });
  }

  obtenerProyectos() {
    this.cargando(true, false);
    this.requestsService2.getAllProjects(this.token).subscribe((data: any) => {
      if (this.rol === 'Administrador') {
        this.proyectos = data
      } else {
        const { proyectosFiltrados, idProyectos } = this.filtrarProyectosService.filtrarProyectos(data, this.usuarioId);
        this.proyectos = proyectosFiltrados;
        this.idProyectos = idProyectos;
        this.cargando(false, false);
      }
    }, (error) => {
      this.messagesService.showError('Se tiene problemas para obtener proyectos.');
    });
  }

  changePage(page: number | string) {
    // Convertir page a number si es una string
    const pageNumber = typeof page === 'string' ? parseInt(page, 10) : page;

    // Verificar si pageNumber es un número válido
    if (typeof pageNumber === 'number' && pageNumber >= 1 && pageNumber <= this.totalPages) {
      this.currentPage = pageNumber;
      this.fetchData(); // Vuelve a cargar los datos para la página seleccionada
    }
  }

  formatearNumeroConComas(numero: number): string {
    return numero.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
  }

  queGuardar(estatus:any,proyecto:any,mes:any,anio:any,buscar:any){
    this.filtrarProyectosService.saveFilter(estatus, proyecto, mes, anio, buscar, 'penalizacion'); 
  }

  editar(op: any, deductiva: any) {
    this.queGuardar(this.estatus, this.proyecto, this.mes, this.anio, this.buscar);
    const opE = op.toString();
    this.sharedService.setData(opE);
    this.sharedService.setDataArray(deductiva)
    this.router.navigate(['/penalizacionD', opE]);
  }

  agregar(op: any) {
    const opE = op.toString()
    this.sharedService.setData(opE);
    this.router.navigate(['/penalizacionD', opE]);
  }

  recargarPagina() {
    this.queGuardar(null, null, null, null, null);
    const currentUrl = this.router.url;
    this.router.navigateByUrl('/', { skipLocationChange: true }).then(() => {
      this.router.navigate([currentUrl]);
    });
  }

  onFiltrosChange(seleccion: string) {
    // regresamos la paginación desde la primer pagina y la busqueda de  5 facturas 
    this.currentPage = 1;
    
    // si no es paginación entra a validación para regresar los datos a lo predeterminado
    if(seleccion !== 'paginas'){
      this.rango = 5;
    }

    this.penalizaciones = this.penalizacionesOriginales;
    if (this.proyecto === undefined || this.proyecto === 0 || this.proyecto === null) {
      this.proyecto = null
    } else {
      this.proyecto = Number(this.proyecto)
    }
    this.getBody();
    this.activarMensaje = 'buscador';
    this.obtenerTodasPenalizacion();
  }

  obtenerTodasPenalizacion() {
    this.cargando(true, false);
    this.requestsService.getAllpenalizacion(this.token, this.body).subscribe(
      (data: any) => {
        this.penalizacionesOriginales = data.data.map((penalizacion: any) => {
          return {
            ...penalizacion,
            DedPen_Anio: penalizacion.DedPen_Año,
            DedPen_MontoFormateado: this.formatearNumeroConComas(penalizacion.DedPen_Monto)
          };
        });
        
        this.penalizaciones = this.penalizacionesOriginales;
        this.currentPage = data.currentPage;
        this.totalPages = data.totalPages;
        
        this.totalPagesArray = Array(this.totalPages).fill(0).map((x, i) => i + 1);
        
        if (this.penalizaciones.length === 0) {
          this.mensajePanalizaciones();
        }

        this.activarDondeQuedo();
        this.adjustMaxVisiblePages();
        this.cargando(false, false);
      }, (err) => {
        this.messagesService.showError('Se tiene problemas para obtener las penalizaciones.')
      });
  }

  mensajePanalizaciones() {
    const mensaje = 'No encontramos penalizaciones, con el siguiente filtro:';
    // Agrega todos los filtros en una lista
    const filtros = [this.buscar, this.estatus, this.proyecto, this.mes];
    // Encuentra el primer filtro no nulo o no indefinido
    const filtroEncontrado = filtros.find(filtro => filtro != null);
    // Asigna el mensaje con el primer filtro encontrado o el mensaje predeterminado
    if (this.activarMensaje === 'buscador') {
      this.mensajePenalizacion = filtroEncontrado ? `${mensaje} ${filtroEncontrado}` : mensaje;
    } else {
      this.mensajePenalizacion = 'No se tienen penalizaciones que mostrar.';
    }

  }

}
